import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import SEO from "../SEO";
import PerformanceOptimizer from "../PerformanceOptimizer";
import LanguageSelectionModal from "../LanguageSelectionModal";
import { useLanguageSelection } from "../../hooks/useLanguageSelection";

function Layout() {
  const { showLanguageModal, handleLanguageSelect } = useLanguageSelection();

  // Default schema for the conference
  const conferenceSchema = {
    "@context": "https://schema.org",
    "@type": "Event",
    name: "19th Asia-Pacific Conference on Giftedness (APCG) 2026",
    startDate: "2026-02-07T09:00",
    endDate: "2026-02-11T17:00",
    location: {
      "@type": "Place",
      name: "University of Business and Technology",
      address: {
        "@type": "PostalAddress",
        addressLocality: "Jeddah",
        addressRegion: "Makkah Province",
        addressCountry: "Saudi Arabia",
      },
    },
    image:
      "https://apcg2026-saudiarabia.org/images/logos/apcg-ubt-white-logo.png",
    description:
      "The Asia-Pacific Conference on Giftedness (APCG) 2026, hosted in Jeddah, Saudi Arabia, is a transformative gathering of global educators, researchers, and practitioners.",
    offers: {
      "@type": "Offer",
      price: "300",
      priceCurrency: "USD",
      availability: "https://schema.org/InStock",
      validFrom: "2025-02-01",
    },
    organizer: {
      "@type": "Organization",
      name: "University of Business and Technology",
      url: "https://www.ubt.edu.sa/",
    },
  };

  return (
    <>
      {/* Default SEO that will be overridden by specific pages */}
      <SEO schemaData={conferenceSchema} />

      {/* Performance optimizer for Core Web Vitals */}
      <PerformanceOptimizer />

      <Header />

      <Outlet />

      <Footer />

      <div className="scroll-progress d-none d-xxl-block">
        <a href="#" className="scroll-top" aria-label="scroll">
          <span className="scroll-text">Scroll</span>
          <span className="scroll-line">
            <span className="scroll-point" />
          </span>
        </a>
      </div>

      {/* Language Selection Modal - Shows on all pages if language not selected */}
      <LanguageSelectionModal
        isOpen={showLanguageModal}
        onLanguageSelect={handleLanguageSelect}
      />
    </>
  );
}

export default Layout;
